// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import Vue from 'vue'
import Router from 'vue-router'

import ApiKeyEdit from '@/components/ApiKeyEdit'
import ApiKeys from '@/components/ApiKeys'
import CustomerEdit from '@/components/CustomerEdit'
import Customers from '@/components/Customers'
import EmailTemplateEdit from '@/components/EmailTemplateEdit'
import FileEdit from '@/components/FileEdit'
import Home from '@/components/Home'
import Index from '@/components/Index'
import ItemEdit from '@/components/ItemEdit'
import Items from '@/components/Items'
import LicenseEdit from '@/components/LicenseEdit'
import Licenses from '@/components/Licenses'
import Login from 'vue-common/components/Login'
import OrganizationEdit from '@/components/OrganizationEdit'
import Organizations from '@/components/Organizations'
import OwnerEdit from '@/components/OwnerEdit'
import Owners from '@/components/Owners'
import PasswordResetConfirm from 'vue-common/components/PasswordResetConfirm'
import PasswordResetForm from 'vue-common/components/PasswordResetForm'
import PasswordResetRequest from 'vue-common/components/PasswordResetRequest'
import PhotoSettings from '@/components/PhotoSettings'
import RoleEdit from '@/components/RoleEdit'
import Roles from '@/components/Roles'
import RuleEdit from '@/components/RuleEdit'
import Rules from '@/components/Rules'
import Settings from '@/components/Settings'
import UserEdit from '@/components/UserEdit'
import UserMe from '@/components/UserMe'
import Users from '@/components/Users'

import LicenseStatus from '@/components/tabs/LicenseStatus.vue'
import LicenseTypes from '@/components/tabs/LicenseTypes'

Vue.use(Router)

Vue.component('license-status', LicenseStatus)
Vue.component('license-types', LicenseTypes)

var router = new Router({
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        // {
        //   path: '',
        //   component: Customers,
        //   name: 'customersHome'
        // },
        {
          path: 'dashboard',
          component: Home,
          name: 'home'
        },
        {
          path: 'apikeys',
          component: ApiKeys,
          name: 'apikeys'
        },
        {
          path: 'apikeys/:id',
          component: ApiKeyEdit,
          name: 'apikeyEdit'
        },
        {
          path: 'customers',
          component: Customers,
          name: 'customers'
        },
        {
          path: 'emailtemplates',
          component: EmailTemplateEdit,
          name: 'emailTemplateEdit'
        },
        {
          path: 'customers/:id',
          component: CustomerEdit,
          name: 'customerEdit'
        },
        {
          path: 'files/:id',
          component: FileEdit,
          name: 'fileEdit'
        },
        {
          path: 'items',
          component: Items,
          name: 'items'
        },
        {
          path: 'items/:id',
          component: ItemEdit,
          name: 'itemEdit'
        },
        {
          path: 'licenses',
          component: Licenses,
          name: 'licenses'
        },
        {
          path: 'licenses/:id',
          component: LicenseEdit,
          name: 'licenseEdit'
        },
        {
          path: 'login',
          component: Login,
          name: 'login'
        },
        {
          path: 'organizations',
          component: Organizations,
          name: 'organizations'
        },
        {
          path: 'organizations/:id',
          component: OrganizationEdit,
          name: 'organizationEdit'
        },
        {
          path: 'owners',
          component: Owners,
          name: 'owners'
        },
        {
          path: 'owners/:id',
          component: OwnerEdit,
          name: 'ownerEdit'
        },
        {
          path: 'passwordreset/confirm',
          component: PasswordResetConfirm,
          name: 'passwordResetConfirm'
        },
        {
          path: 'passwordreset/request',
          component: PasswordResetRequest,
          name: 'passwordResetRequest'
        },
        {
          path: 'roles',
          component: Roles,
          name: 'roles'
        },
        {
          path: 'roles/:id',
          component: RoleEdit,
          name: 'roleEdit'
        },
        {
          path: 'rules',
          component: Rules,
          name: 'rules'
        },
        {
          path: 'rules/:id',
          component: RuleEdit,
          name: 'ruleEdit'
        },
        {
          path: 'settings',
          component: Settings,
          name: 'settingsEdit'
        },
        {
          path: '/settings/photos',
          component: PhotoSettings,
          name: 'settingsPhotoEdit'
        },
        {
          path: 'userme',
          component: UserMe,
          name: 'userMe'
        },
        {
          path: 'users',
          component: Users,
          name: 'users'
        },
        {
          path: 'users/:id',
          component: UserEdit,
          name: 'userEdit'
        },
        // catch all redirect
        {
          path: '*',
          redirect: '/customers'
        }
      ]
    },
    {
      path: '/passwordreset/form',
      component: PasswordResetForm,
      name: 'passwordResetForm'
    },
    // catch all redirect
    {
      path: '*',
      redirect: '/customers'
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js